import { createContext, useContext } from 'react';
import { NavigableError, ErrorsNavigationService } from 'services/errorsNavigation/errorsNavigation';
import { GenericError } from 'support/helpers/errors/errors';
import { useErrorModal } from './useErrorModal';

type ErrorModalComponentProps<T> = {
  [key: string]: unknown;
  error: T | undefined;
};
// Generic provider that can be configured for different error types
export type ErrorsNavigationContextType<T extends NavigableError> = {
  ErrorModalComponent: React.ComponentType<ErrorModalComponentProps<T> & any> | null;
  service: ErrorsNavigationService<T>;
  useErrorModal: typeof useErrorModal;
};

// Create the context
export const ErrorsNavigationContext = createContext<ErrorsNavigationContextType<any> | null>(null);
// Create a hook for easy access
export function useErrorContext<T extends NavigableError>(): ErrorsNavigationContextType<T> {
  const context = useContext(ErrorsNavigationContext);
  if (!context) {
    throw new GenericError('useErrorContext must be used within an ErrorContextProvider');
  }
  return context as ErrorsNavigationContextType<T>;
}
